window.copyToClipboard = async (text, id) => {
    await navigator.clipboard.writeText(text);
    document.getElementById('copied-to-clipboard-'+id).classList.remove('invisible');
    setTimeout(
        () => document.getElementById('copied-to-clipboard-'+id).classList.add('invisible'),
        1500
    );
};
